import { observable } from 'mobx';
import { autobind } from 'core-decorators';
import { noop } from '@src/utils/common-util';

class GiftModalStore {
  onClose = noop;
  /**
   * 弹窗是否打开
   * @type {boolean}
   */
  @observable isOpen = false;

  /**
   * 点击关闭时回调
   */
  @autobind
  onCloseHandler() {
    this.isOpen = false;
    this.onClose();
  }

  use() { }
}

export default GiftModalStore;
